import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { AppSettings } from '../providers/app-settings';

@Injectable()
export class ActivityService {
  private activityApiUrl: string;

  constructor(public http: Http, private appSettings: AppSettings) {
    this.activityApiUrl = this.appSettings.DB_API_ENDPOINT + 'activities/';
  }

  private getDataInJson(res: Response) {
    return res.json();
  }

  public getAllActivities(): Promise<Array<any>> {
    return  this.http.get(this.activityApiUrl, this.appSettings.apiOptions)
                .toPromise()
                .then(this.getDataInJson);
  }

  public addActivity(activity): Observable<any> {
    return  this.http.post(this.activityApiUrl, activity, this.appSettings.apiOptions)
                .map(this.getDataInJson);
  }

  public delActivity(id): Observable<any> {
    return this.http.delete(this.activityApiUrl + id, this.appSettings.apiOptions);
  }

  public editActivity(editActivity): Observable<any> {
    return this.http.put(this.activityApiUrl + editActivity._id, editActivity, this.appSettings.apiOptions);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/activity.service.ts